'use client'

import type { CSSProperties } from 'react'
import { useScrollProgress } from '../../lib/use-scroll-progress'

/* The two-registry story as a pinned split screen. Copy is verbatim
   from the static roster-halves section this replaces; list items
   surface one by one as the reader scrolls through. */
const HALVES = [
  {
    eyebrow: 'Mortgage · NMLS',
    title: 'Mortgage Loan Originators',
    body: 'Every MLO renews in the same window: November 1 to December 31, with per-day late penalties waiting on the other side. Seats works every originator all year so the window is a formality, not a fire drill.',
    items: [
      ['MU4 filings', ', drafted per person and submitted through NMLS after internal review.'],
      ['Sponsorship management', ' as originators join, move between branches, and leave.'],
      ['Continuing education tracking', ' against each state’s hour requirements, ahead of the deadline.'],
      ['Renewal window execution', ', filed as each person becomes ready instead of in a December pile.'],
    ],
  },
  {
    eyebrow: 'Insurance · NIPR',
    title: 'Adjusters & Producers',
    body: 'Adjusters carry licenses across many states at once, and a catastrophe can send them anywhere. Seats keeps everyone licensed where the work is, before the work arrives.',
    items: [
      ['Multi-state licensing', ' per person, applied for and renewed through NIPR.'],
      ['Catastrophe deployment readiness', ': know which adjusters can legally work a state before deployment.'],
      ['Roster-wide verification', ' before claims are assigned, so no claim lands on a lapsed license.'],
      ['Producer appointments', ' tracked alongside the licenses they depend on.'],
    ],
  },
]

export function SeatsRegistries() {
  const ref = useScrollProgress<HTMLElement>()

  return (
    <section
      ref={ref}
      className="pin-section pin-section-alt"
      style={{ height: '280vh' }}
    >
      <div className="pin-frame">
        <div className="year-inner">
          <p className="section-label">TWO REGISTRIES</p>
          <h2 className="subpage-heading">
            Mortgage runs on NMLS. Insurance runs on NIPR. Payna speaks both.
          </h2>
          <div className="roster-halves">
            {HALVES.map((half, h) => (
              <div key={half.eyebrow} className="roster-half">
                <span className="roster-half-eyebrow">{half.eyebrow}</span>
                <h3>{half.title}</h3>
                <p>{half.body}</p>
                <ul className="roster-list">
                  {half.items.map(([strong, rest], i) => (
                    <li
                      key={strong}
                      className="registry-item"
                      style={
                        { '--t': 0.15 + (i * 2 + h) * 0.09 } as CSSProperties
                      }
                    >
                      <strong>{strong}</strong>
                      {rest}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
